//should type userDetails as tech debt
const getUserRoles = (userDetails: any): string => {
  let roles = [];
  if (userDetails?.administrator_role) {
    roles.push('Admin');
  }
  if (userDetails?.caller_role) {
    roles.push('Caller');
  }
  if (userDetails?.client_administrator_role) {
    roles.push('Client Admin');
  }
  if (userDetails?.listener_role) {
    roles.push('Listener');
  }
  const rolesList = roles.reduce((role, currentValue) => `${role}${currentValue}, `, '');
  //get back a string of all roles, remove the trailing comma
  return rolesList.slice(0, rolesList.length - 2);
};

export default getUserRoles;
